<template>
    <div class="keyword_box">
        <div class="key_topTit">Create P&L Category</div>
        <div class="key_topBtn_group">
            <div class="keyTop_btn" style="color:#EA3796;border-color:#EA3796;" @click="addKeyword">Add Keywords</div>
            <div class="keyTop_btn" @click="keyWordDio=true,getDioList()">New Keywords
                <div class="key_numBox1" v-if="num">{{num>99?'99+':num}}</div>
            </div>
        </div>
        <div>
			<el-table
			:data="tableData"
			border
			class="roster_table fee_table"
			style="width: 100%">
				<el-table-column
				prop="title"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="TITLE">
				</el-table-column>
				<el-table-column
				prop="sort"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="SORT">
                    <template slot-scope="scope">
                        {{scope.row.sort==0?'Fixed OH':'Variable OH'}}
                    </template>
				</el-table-column>
				<el-table-column
				prop="address"
				align="right"
				label-class-name="roster_th"
				class-name="roster_row"
				label="OPERATION">
					<template slot-scope="scope">
                        <div class="key_tableBtn_group">
                            <div class="key_editBtn" @click="edit(scope.row.id)">Edit</div>
                            <div class="key_delBtn" @click="remove(scope.row.id)">Remove</div>
                        </div>
					</template>
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
                    :current-page.sync="page"
                    @current-change='changePage'
					layout="prev, pager, next"
					:page-size="10"
					:total="total">
				</el-pagination>
			</div>
		</div>

        <el-dialog
        title="Keywords List"
        :visible.sync="keyWordDio"
        :modal-append-to-body="false"
        :show-close='true'
        class="keyWordDio"
        :close-on-click-modal='false'
        width="840px">
            <div>
                <el-table
                :data="tableData2"
                border
                class="roster_table fee_table"
                style="width: 100%">
                    <el-table-column
                    prop="date"
                    align="left"
                    label-class-name="roster_th"
                    class-name="roster_row"
                    label="Date">
                    </el-table-column>
                    <el-table-column
                    prop="venue"
                    align="left"
                    label-class-name="roster_th"
                    class-name="roster_row"
                    label="Venue">
                    </el-table-column>
                    <el-table-column
                    prop="address"
                    align="left"
                    label-class-name="roster_th"
                    class-name="roster_row"
                    label="Keyword">
                        <template slot-scope="scope">
                            <div>{{scope.row.keyword}}</div>
                        </template>
                    </el-table-column>
                    <template slot="empty">
                        <i v-if="loading2" class="el-icon-loading" style="font-size:20px"></i>
                        <div v-else>-</div>
                    </template>
                </el-table>
                <div class="ros_footerPage" v-if="total1>10">
                    <el-pagination
                        class="my_pageSel"
                        @current-change='changePage1'
                        layout="prev, pager, next"
                        :current-page.sync="page1"
                        :page-size="10"
                        :total="total1">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '../../api/category'

export default {
    data() {
        return {
            keyWordDio:false,
            tableData:[], // 主体表格
            tableData2:[], // 弹窗表格
            page: 1,
            page1:1,
            size: 10,
            total: 0,
            total1: 0,
            loading: true, // 主体表格加载
            loading2: true, // 弹窗表格加载
            num: null // 数量
        }
    },
    created () {
        let params = JSON.stringify(this.$route.params)
        if(params!='{}'){
            this.page = Number(JSON.parse(params).page)
        }
        this.getLists()
    },
    methods: {
        getLists(){
            var that = this
            // 获取主体列表
            api.keyList({
                params: {
                    pageNum: that.page,
                    pageSize: that.size
                },
                callback: that.listCallback
            })
            // 获取未补充的关键字数量
            api.nums({
                callback: that.numsCallback
            })
        },
        changePage(page){
            this.page=page
            this.getLists()
        },
        changePage1(page){
            this.page1=page
            this.getDioList()
        },
        getDioList(){ // 未补充关键字列表
            this.loading2=true
            let pat={
                pageNum: this.page1,
                pageSize: this.size 
            }
            api.getMissingKeywordsList({'params':pat,callback:res=>{
                let {code,message,data}=res.data;
                this.loading2=false;
                if(code==0){
                    this.tableData2=data.list
                    this.total1 = data.total
                    this.tableData2.forEach(item=>{
                        item.date=Utils.timeFotmatYMD(item.date)
                    })
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        },
        addKeyword(){
            this.$router.push({path:'/keyword',query:{type:'a'}})
        },
        edit(id){
            window.sessionStorage.setItem('keywordPage',this.page)
            this.$router.push({path:'/keyword',query:{type:'e',id:id}})
        },
        remove(id) {
            api.deleteKeywords({params:{id:id},callback:res=>{
                let {code,message,data}=res.data;
                if(code==0){
                    this.getLists()
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        },
        // 列表回调
        listCallback (res) {
            var that = this
            that.loading = false
            if (res.data.code == 0) {
                if (that.page > 1 && res.data.data.list === 0) {
                    that.page --
                    that.getLists()
                    return
                }
                that.total = res.data.data.total
                that.tableData = res.data.data.list
            } else {
                that.$box.alert('', res.data.message, 'error')
            }
        },
        // 数量回调
        numsCallback (res) {
            var that = this
            if (res.data.code == 0) {
                that.num = Number(res.data.data)
            } else {
                that.$box.alert('', res.data.message, 'error')
            }
        }
    },
}
</script>

<style lang="scss">
    .keyword_box{
        .key_topTit{
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 40px;
        }
        .key_topBtn_group{
            display: flex;
            .keyTop_btn{
                width: 280px;
                height: 60px;
                line-height: 60px;
                font-size:26px;
                font-weight:600;
                color: #fff;
                margin-right: 30px;
                margin-bottom: 30px;
                border: 2px solid #fff;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                .key_numBox1{
                    float: right;
                    box-sizing: border-box;
                    text-align: center;
                    width:30px;
                    height:30px;
                    background:rgba(234,55,150,1);
                    color: #fff;
                    font-size:16px;
                    font-weight: 600;
                    line-height: 30px;
                    // padding: 2px;
                    border-radius: 50%;
                    margin-right: 20px;
                    margin-top: 14px;
                }
            }
        }
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: flex-end;
        }
        .key_editBtn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid rgba(234,55,150,1);
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: rgba(234,55,150,1);
            margin-right: 10px;
            cursor: pointer;
        }
        .key_delBtn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/CreateCategory/keywordList.vue